import PropTypes from 'prop-types';

// material-ui
import { useTheme } from '@mui/material/styles';
import { Avatar, Box, ButtonBase, Tooltip, FormControlLabel, Switch } from '@mui/material';

// project imports
import LogoSection from '../LogoSection';

//import NotificationSection from './NotificationSection';

// assets
import SimpleProfileSection from './ProfileSection/SimpleProfileSection';
import { IconMenu2 } from '@tabler/icons';
import { MenuOpen } from '@mui/icons-material';
import NotificationSection from './NotificationSection';
import NotificationSectionV2 from './NotificationSectionV2';
import ReferralSection from './ReferralSection';
import WelcomePopup from './Welcome/Welcome.popup';
import { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { toggleStagingPreview } from 'store/Shared.Slice';

// ==============================|| MAIN NAVBAR / HEADER ||============================== //

const Header = () => {
    const theme = useTheme();
    const dispatch = useDispatch();
    const [welcomeClosed, setWelcomeClosed] = useState(false);

    const { userToken, previewStagingEnabled } = useSelector((state) => state.sharedState);
    const userRoles = Array.isArray(userToken?.role) ? userToken.role : [userToken?.role].filter(Boolean);
    const isAdminOrSuperAdmin = userRoles.includes('Admin') || userRoles.includes('SuperAdmin');

    return (
        <>
            {/* logo & toggler button */}
            <Box
                sx={{
                    width: 228,
                    display: 'flex',
                    [theme.breakpoints.down('md')]: {
                        width: 'auto'
                    },
                    [theme.breakpoints.down('960')]: {
                        width: '160px'
                    },
                    [theme.breakpoints.down('sm')]: {
                        width: '100px'
                    },
                }}
            >
                <Box component="span" sx={{ display: 'block', flexGrow: 1 }}>
                    <LogoSection />
                </Box>
            </Box>

            {/* header search */}
            {/*<SearchSection /> */}

            <Box ml={8} sx={{
                [theme.breakpoints.down('1100')]: {
                    marginLeft: 0,
                }
            }}>
                <ReferralSection />
            </Box>
            
            <Box sx={{ flexGrow: 1 }} />

            {isAdminOrSuperAdmin && (
                <FormControlLabel
                    sx={{ mr: 2 }}
                    control={
                        <Switch
                            checked={!!previewStagingEnabled}
                            onChange={() => dispatch(toggleStagingPreview())}
                            color="warning"
                        />
                    }
                    label="Preview Staging"
                />
            )}

            {/* notification & profile */}
            {/* <NotificationSection /> */}

            <WelcomePopup onCloseWelcome={() => { setWelcomeClosed(true); }} />
            <NotificationSectionV2 welcomeClosed={welcomeClosed} />
            <SimpleProfileSection />
        </>
    );
};

Header.propTypes = {
    handleLeftDrawerToggle: PropTypes.func
};

export default Header;
